import {
  getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions,
  getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** 対象モデル（c: Client, up: UserProfile） */
  target: string;
};

type ReturnType = {
  /** カスタムフィールド定義データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions200;
};

/**
 * useGetCustomFieldDefinitionsフックの型定義
 */
type IUseGetCustomFieldDefinitions = (args: Args) => ReturnType;

/**
 * カスタムフィールド定義取得フック
 */
export const useGetCustomFieldDefinitions: IUseGetCustomFieldDefinitions = ({
  threeLetterCode,
  target,
}) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitionsKey(threeLetterCode, {
      f: target,
    }),
    () =>
      getApiV1ThreeLetterCodePartnerAdminsCustomFieldDefinitions(threeLetterCode, { f: target }),
    { suspense: true }
  );

  return {
    data,
  };
};
